import {
    logDebug,
    logInfo,
    logWarn,
    logError,
    logEvent,
} from '../../tracing.js';

const validateGoogleData = (prop, defaultValue) => {
    if (!window.googleData) {
        throw new Error('window.googleData is not defined');
    }
    if (
        window.googleData[prop] === null ||
        window.googleData[prop] === undefined
    ) {
        if (defaultValue !== undefined) {
            logWarn(
                `${prop} is not defined on window.googleData. Falling back ${defaultValue}`
            );
            return defaultValue;
        } else {
            throw new Error(`${prop} is not defined on window.googleData`);
        }
    }
    logDebug(
        `Google data prop found. Retrieving prop ${prop} with value ${window.googleData[prop]}`
    );
    return window.googleData[prop];
};
const validateEcommerceData = (prop, defaultValue) => {
    if (!window.ecommerceData) {
        throw new Error('window.ecommerceData is not defined');
    }
    if (
        window.ecommerceData[prop] === null ||
        window.ecommerceData[prop] === undefined
    ) {
        if (defaultValue !== undefined) {
            logWarn(
                `${prop} is not defined on window.ecommerceData. Falling back ${defaultValue}`
            );
            return defaultValue;
        } else {
            throw new Error(`${prop} is not defined on window.ecommerceData`);
        }
    }
    logDebug(
        `Ecommerce data prop found. Retrieving prop ${prop} with value ${window.ecommerceData[prop]}`
    );
    return window.ecommerceData[prop];
};

const extractAdwordsConfiguration = () => {
    const adwordsConfiguration = validateGoogleData('adwordsConfiguration');
    const ads = JSON.parse(adwordsConfiguration.replace(/&quot;/g, '"'));
    return ads;
};
export {
    validateGoogleData,
    extractAdwordsConfiguration,
    validateEcommerceData,
};
